export enum StorageKeysEnum {
    ShowProductUpselling = 'showProductUpselling',
    Tier = 'tier',
    Fingerprint = 'fingerprint',
    SubaccountEmailToUse = 'subaccountemailtouse',
    SSLDomainDeletion = 'SSLDomainDeletion',
    ReshardInProgressAlert = 'reshardInProgressAlert',
    ReshardConfirmationAlert = 'reshardConfirmationAlert',
}
